// extracted by mini-css-extract-plugin
export default {"tasks":"ZN-z","task":"_N-z","svg":"aO-z","text":"bO-z"};